/**
 * Create by zhijie.huang on 2018/9/7
 * Tool 工具函数
 */

/**
 * https://github.com/component/type
 * Return the type of `val`. 返回类型
 *
 * @param {Mixed} val
 * @return {String}
 * @api public
 */
import debounce from './lodash/debounce' // 防抖动
import throttle from './lodash/throttle' // 节流阀

function getType(val) {
  switch (Object.prototype.toString.call(val)) {
    case '[object Date]': return 'date'
    case '[object RegExp]': return 'regexp'
    case '[object Arguments]': return 'arguments'
    case '[object Array]': return 'array'
    case '[object Error]': return 'error'
  }

  if (val === null) { return 'null' }
  if (val === undefined) { return 'undefined' }
  if (val !== val) { return 'nan' } // eslint-disable-line
  if (val && val.nodeType === 1) { return 'element' }

  val = val.valueOf
    ? val.valueOf()
    : Object.prototype.valueOf.apply(val)

  return typeof val
}

/**
 * singleton 生成单例
 * @param {*} fn
 */
function getInstance(fn) {
  let instance
  return function () {
    // console.log('instance=', instance, this);
    if (!instance) instance = fn.apply(this, arguments)
    return instance
  }
}

/**
 * 复制对象
 * @param {deep: Boolean, targetObject: Object, CopyObject: Object} 是否深度复制、目标对象、复制对象
 */
function extend() {
  var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, // eslint-disable-line one-var
    i = 1,
    length = arguments.length,
    deep = false,
    toString = Object.prototype.toString,
    hasOwn = Object.prototype.hasOwnProperty,
    class2type = {
      '[object Boolean]': 'boolean',
      '[object Number]': 'number',
      '[object String]': 'string',
      '[object Function]': 'function',
      '[object Array]': 'array',
      '[object Date]': 'date',
      '[object RegExp]': 'regexp',
      '[object Object]': 'object'
    },
    jQuery = {
      isFunction: function (obj) {
        return jQuery.type(obj) === 'function'
      },
      isArray: Array.isArray ||
        function (obj) {
          return jQuery.type(obj) === 'array'
        },
      type: function (obj) {
        return obj == null ? String(obj) : class2type[toString.call(obj)] || 'object'
      },
      isPlainObject: function (obj) {
        if (!obj || jQuery.type(obj) !== 'object' || obj.nodeType) {
          return false
        }
        try {
          if (obj.constructor && !hasOwn.call(obj, 'constructor') && !hasOwn.call(obj.constructor.prototype, 'isPrototypeOf')) {
            return false
          }
        } catch (e) {
          return false
        }
        var key
        return key === undefined || hasOwn.call(obj, key)
      }
    }
  if (typeof target === 'boolean') {
    deep = target
    target = arguments[1] || {}
    i = 2
  }
  if (typeof target !== 'object' && !jQuery.isFunction(target)) {
    target = {}
  }
  if (length === i) {
    target = this
    --i
  }
  for (i; i < length; i++) {
    if ((options = arguments[i]) != null) {
      for (name in options) {
        src = target[name]
        copy = options[name]
        if (target === copy) {
          continue
        }
        if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = jQuery.isArray(copy)))) {
          if (copyIsArray) {
            copyIsArray = false
            clone = src && jQuery.isArray(src) ? src : []
          } else {
            clone = src && jQuery.isPlainObject(src) ? src : {}
          }
          // WARNING: RECURSION
          target[name] = extend(deep, clone, copy)
        } else if (copy !== undefined) {
          target[name] = copy
        }
      }
    }
  }
  return target
}

/**
 * 根据对象的value找key
 * @param {*} object 目标对象
 * @param {*} value
 */
function getKeyByValue(object, value) {
  return Object.keys(object).find(key => object[key] === value)
}

export {
  debounce,
  throttle,
  getType,
  getInstance,
  extend,
  getKeyByValue
}
